// extracted by mini-css-extract-plugin
export default {"pageFrame":"BasePage_pageFrame__Z33GX","coloredBackground":"BasePage_coloredBackground__6kDXV","pageContainer":"BasePage_pageContainer__5hNB-"};